module.exports = __webpack_public_path__ + "static/media/140B93BB-A364-4B24-AF32-98BBC1DE565A.b0d4e291.JPG";